/*=========================================================================================
  File Name: moduleStats.js
  Description: Auth Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import state from './moduleStatsState.js';
import mutations from './moduleStatsMutations.js';
import actions from './moduleStatsActions.js';
import getters from './moduleStatsGetters.js';

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};
